export enum CompanySize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  XLARGE = "XLARGE",
}

export enum Status {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DELETED = "deleted",
}

export enum BusinessEmployeeStaatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DELETED = "deleted",
  INVITING = "inviting",
}

export enum BusinessEmployeeRole {
  OWNER = "owner",
  MANAGER = "manager",
  COLLABORATOR = "collaborator",
}

export enum MoneyUnit {
  vnd = "vnd",
  usd = "usd",
}

export enum SortType {
  asc = "asc",
  desc = "desc",
}

export enum PostType {
  normal = "normal",
  special = "special",
  hot = "hot",
}

export enum StatusPurchase {
  pending = "pending",
  success = "success",
  failed = "failed",
  processing = "processing",
}

export enum JobType {
  fullTimeOffice = "fullTimeOffice",
  partTimeOffice = "partTimeOffice",
  fullTimeRemote = "fullTimeRemote",
  partTimeRemote = "partTimeRemote",
  fullTimeHybrid = "fullTimeHybrid",
  partTimeHybrid = "partTimeHybrid",
  freelance = "freelance",
}

export enum Gender {
  male = "male",
  female = "female",
  other = "other",
}

export enum InterviewRoomType {
  inPerson = "INTERVIEW_TYPE_IN_PERSON",
  online = "INTERVIEW_TYPE_ONLINE",
  phone = "INTERVIEW_TYPE_PHONE",
}

export enum InterviewStatus {
  pending = "INTERVIEW_STATUS_PENDING",
  accepted = "INTERVIEW_STATUS_ACCEPTED",
  denied = "INTERVIEW_STATUS_DENIED",
  completed = "INTERVIEW_STATUS_COMPLETED",
}

export enum ReviewCriteria {
  benefitsCriteria = "benefits_criteria",
  cultureCriteria = "culture_criteria",
  careerCriteria = "career_criteria",
  managementCriteria = "management_criteria",
  workLifeBalanceCriteria = "work_life_balance_criteria",
}

export enum ContentType {
  image = "IMAGE",
  video = "VIDEO",
  link = "LINK",
  text = "TEXT",
  audio = "AUDIO",
  file = "FILE",
}
